// extracted by mini-css-extract-plugin
export default {"container":"Projects_container__MaVS7","imgText":"Projects_imgText__T-xJf","imgFromTop":"Projects_imgFromTop__P+2T2"};